import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const WorkoutRoutineCard = () => {
  return (
    <div className="container my-4 py-4">
      <h6 className="text-left fw-bold">Notification Preference:</h6>
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>Workout Routines:</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="notificationSwitch"
                defaultChecked
              />
              <label className="form-check-label" htmlFor="notificationSwitch">
                On
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>Offers:</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="offersSwitch"
              />
              <label className="form-check-label" htmlFor="offersSwitch">
                Off
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutRoutineCard;
